


















import Vue from 'vue'
import Component from 'vue-class-component'
import { IAddPatchRequest } from '../model/ProductsState'
import  ProductService  from '../services/ProductsService'

@Component({})
export default class AddPatch extends Vue {
    productId: number;
    versionId: number;
    productService: ProductService;
    isLoading: boolean;
    mandatoryPatch: boolean;
    file: any;
    patchName = "";
    patchDescription = "";
    patchNumber = "";
    patchChangelog = "";
    patchForm = {}

    form = false;


    constructor () {
        super();
        this.isLoading = false;
        this.productService = new ProductService();
        this.productId = -1;
        this.versionId = -1;
        this.mandatoryPatch = false;
    }

    mounted(){
        this.productId = +this.$route.params.productId
        this.versionId = +this.$route.params.versionId
    }

    onFileChange(file: any){
        this.file = file
    }

    submit(){
        const addPatchRequest: IAddPatchRequest = {name: this.patchName, number: this.patchNumber,
            description: this.patchDescription, changeLog: this.patchChangelog,
            mandatoryPatch: this.mandatoryPatch,
            versionId: this.versionId, userId: this.$store.state.user.user.id}

        this.productService.addPatch(addPatchRequest, this.file).then(() => {
            this.$router.push({name: "Product", params: {id: ""+this.productId}})
        });
    }

    abort(){
        this.$router.push({name: "Product", params: {id: ""+this.productId}})
    }
}
